import React from "react";

import { connect } from "react-redux";

const HRMessage = ({ user, hrMessage }) => {
  // console.log(hrMessage);
  return (
    <>
      {!!hrMessage && (
        <div className="alert alert-warning my-alert text-center" role="alert" style={{backgroundColor: "#ffcb2d"}}>
          <i className="fas fa-bell mr-2"></i>
          <strong>MIFOTRA</strong> <span dangerouslySetInnerHTML={{ __html: hrMessage }} />
        </div>
        // <div
        //   className="alert alert-warning  py-0 mb-0 weak-password-div  text-center text-uppercase"
        //   style={{
        //     borderTopColor: "#ff5722",
        //     borderBottomColor: "#ff5722",
        //     borderRadius: "0px",
        //     height: "28px",
        //     fontSize: "12px",
        //     backgroundColor: "#F5B027",
        //   }}
        // >
        //   {/* <marquee behavior="" direction=""> */}
        //   <strong
        //     dangerouslySetInnerHTML={{ __html: hrMessage }}
        //     className="pt-2"
        //   />
        //   {/* </marquee> */}
        // </div>
      )}
    </>
  );
};

const mapStateToProps = ({ user, hrMessage }) => {
  return {
    user,
    hrMessage,
  };
};

export default connect(mapStateToProps)(HRMessage);
